export default {
  mutations: {
    setWhoWeAre(state, payload) {
      state.whoWeAre = payload;
    },
  },
};
